import { createRef } from 'react';
import { isWeb } from 'src/utils';

export const chatboxRef = createRef();

export const scrollBottom = () => {
  if (!chatboxRef.current) return;
  if (isWeb()) {
    chatboxRef.current?.scrollTo({
      top: chatboxRef.current.scrollHeight || 0,
      left: 0,
      behavior: 'smooth',
    });
  } else {
    chatboxRef.current?.scrollToEnd({ duration: 100, animated: true });
  }
};
